import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { BookingForm } from "../../components/BookingForm";
import { Link } from "react-router-dom";
import { Fade, Zoom } from "react-awesome-reveal";
import { useDispatch, useSelector } from "react-redux";
import { fetchItinerariesPage } from "../../data/itinerariesPageSlice";
import Loader from "../../Loader";
import { useMediaQuery } from "react-responsive";

const Itineraries = () => {
  const language = useSelector((state) => state.language.language);
  let hotelUrl = "";
  if (window.location.href.includes("/agatha-christie-dahabiya")) {
    hotelUrl = "agatha-christie-dahabiya";
  } else if (window.location.href.includes("/nile-capital-cruise")) {
    hotelUrl = "nile-capital-cruise";
  }
  const dispatch = useDispatch();
  const { data, loading, error } = useSelector(
    (state) => state.itinerariesPage
  );

  useEffect(() => {
    dispatch(fetchItinerariesPage({ language, hotelUrl }));
  }, [dispatch, language, hotelUrl]);
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1000 });
  return (
    <>
      {error ? (
        error.message
      ) : (
        <>
          {loading ? (
            <Loader />
          ) : (
            <>
              <Helmet>
                <meta
                  name="description"
                  content={data.pageMetatagDescription}
                />
                <meta name="keywords" content={data.pageMetatagTitle} />

                <title>{data.pageTitle}</title>
              </Helmet>
              {/*banner */}

              <section>
                <div
                  className="breadcumb-area d-flex align-items-center"
                  style={{
                    background: `url(${
                      isMobile
                        ? data?.pageBannerMobile
                        : isTablet
                        ? data?.pageBannerTablet
                        : data?.pageBanner
                    })`,
                  }}
                >
                  <div className="container">
                    <div className="row align-items-center">
                      <div className="col-md-12">
                        <div className="breacumb-content">
                          <Zoom duration="2500">
                            <div className="breadcum-title">
                              <h4>{data.pageTitle}</h4>
                            </div>
                          </Zoom>
                          <Fade duration="2500" direction="up">
                            <ul>
                              <li>
                                <Link
                                  to={`/${hotelUrl}`}
                                  style={{ color: "#fff" }}
                                >
                                  {language === "en" ? "Home" : "الرئيسية"}
                                </Link>
                              </li>
                              <li className="px-2"> / </li>
                              <li> {data.pageTitle}</li>
                            </ul>
                          </Fade>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              {/*booking form */}

              {window.location.href.includes("agatha") ? "" : <BookingForm />}
              {/*Itineraries list */}
              <section>
                <div className="pricing-area">
                  <div className="container">
                    <div className="row">
                      <div className="col-md-12 text-center">
                        <div
                          className="section-title center inner"
                          data-cue="zoomIn"
                        >
                          <div className="section-thumb">
                            <img src="section-shape1.png" alt="" />
                          </div>
                          <h1>{data.pageTitle}</h1>
                          <p className="section-desc-1">{data.pageText}</p>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      {data.list_Itineraries?.map((itinerary, index) => (
                        <div className="col-12 col-md-12 col-lg-4 " key={index}>
                          <div className="single-pricing-box" data-cue="zoomIn">
                            <div className="pricing-thumb">
                              <img
                                src={itinerary.itineraryPhoto}
                                alt={itinerary.itineraryName}
                              />
                              <div className="pircing-text text-center">
                                <h4> {itinerary.itineraryDestination} </h4>
                              </div>
                            </div>
                            <div className="pricing-content">
                              <div className="price">
                                {language === "en" ? (
                                  <h4>{itinerary.numberOfDays} Days</h4>
                                ) : (
                                  <h4>{itinerary.numberOfDays} ايام </h4>
                                )}
                                {language === "en" ? (
                                  <span>
                                    / {itinerary.numberOfNights} Nights
                                  </span>
                                ) : (
                                  <span>
                                    / {itinerary.numberOfNights} ليالي
                                  </span>
                                )}
                              </div>
                              <div className="pricing-item">
                                <ul>
                                  <li
                                    dangerouslySetInnerHTML={{
                                      __html: `${itinerary.itineraryIntro}`,
                                    }}
                                  ></li>
                                </ul>
                              </div>
                              <div className="pricing-button">
                                <Link
                                  to={`/${hotelUrl}/itineraries/${itinerary.itineraryURL}`}
                                >
                                  {language === "en"
                                    ? "Learn more"
                                    : "عرض المزيد"}
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </section>
            </>
          )}
        </>
      )}
    </>
  );
};
export default Itineraries;
